import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpEvent,
  HttpHandler,
  HttpRequest,
  HttpErrorResponse,
} from '@angular/common/http';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { catchError, filter, switchMap, take } from 'rxjs/operators';
import { Store } from '@services/store.service';
import { SeguroStore } from '@interfaces/seguro-store.interface';
import { LoginService } from '@providers/login.service';
import { Router } from '@angular/router';

@Injectable()
export class RefreshTokenInterceptor implements HttpInterceptor {
  refreshTokenInProgress = false;
  accessTokenSubject = new BehaviorSubject<string | null>(null);

  constructor(
    private store: Store<SeguroStore>,
    private loginService: LoginService,
    private router: Router
  ) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((e: HttpErrorResponse) => {
        const hasToken = !!this.store.getState()?.token;
        if (e instanceof HttpErrorResponse && e.status === 401 && hasToken) {
          if (!this.refreshTokenInProgress) {
            this.refreshTokenInProgress = true;
            this.accessTokenSubject.next(null);
            return this.loginService.obtenerToken().pipe(
              switchMap((authResponse) => {
                const state = this.store.getState();
                this.store.setState({
                  ...state,
                  token: authResponse.token,
                });

                this.refreshTokenInProgress = false;
                this.accessTokenSubject.next(authResponse.token);
                req = req.clone({
                  setHeaders: {
                    authorization: `Bearer ${authResponse.token}`,
                  },
                });
                return next.handle(req);
              }),
              catchError((e: HttpErrorResponse) => {
                this.refreshTokenInProgress = false;
                this.router.navigateByUrl('/error', {
                  state: {
                    subtitle: 'Tu sesión ha expirado',
                    title: 'Error de autenticación',
                    subDescription: 'Por favor, inicia sesión nuevamente',
                  },
                });
                return throwError(e);
              })
            );
          } else {
            return this.accessTokenSubject.pipe(
              filter((accessToken) => accessToken !== null),
              take(1),
              switchMap((token) => {
                req = req.clone({
                  setHeaders: {
                    authorization: `Bearer ${token}`,
                  },
                });
                return next.handle(req);
              })
            );
          }
        }
        return throwError(e);
      })
    );
  }
}
